export const emptyVisaEnquiryForm = () => ({
  firstName: '',
  middleName: '',
  lastName: '',
  dateOfBirth: '',
  nationality: '',
  cityCountryOfBirth: '',
  passportNo: '',
  passportDateOfIssue: '',
  passportPlaceOfIssue: '',
  gender: '',
  maritalStatus: '',
  residentialAddress: '',
  postalCode: '',
  mobileNo: '',
  landlineNo: '',
  email: '',
  alternativeEmail: '',
  occupation: '',
  emergencyFullName: '',
  emergencyRelation: '',
  emergencyContactNo: '',
  emergencyEmail: '',
  emergencyAddress: '',
  emergencyPostalCode: '',
  sponsorFullName: '',
  sponsorRelation: '',
  sponsorContactNo: '',
  sponsorEmail: '',
  sponsorProfession: '',
  sponsorAddress: '',
  sponsorPostalCode: '',
  intendedCountry: '',
  purposeOfVisit: '',
  travelMonthYear: '',
});

export const mapVisaEnquiryFromApi = (row) => ({
  enquiryId: row.enquiry_id || '',
  firstName: row.first_name || '',
  middleName: row.middle_name || '',
  lastName: row.last_name || '',
  dateOfBirth: row.date_of_birth ? String(row.date_of_birth).split('T')[0] : '',
  nationality: row.nationality || '',
  cityCountryOfBirth: row.city_country_of_birth || '',
  passportNo: row.passport_no || '',
  passportDateOfIssue: row.passport_date_of_issue ? String(row.passport_date_of_issue).split('T')[0] : '',
  passportPlaceOfIssue: row.passport_place_of_issue || '',
  gender: row.gender || '',
  maritalStatus: row.marital_status || '',
  residentialAddress: row.residential_address || '',
  postalCode: row.postal_code || '',
  mobileNo: row.mobile_no || '',
  landlineNo: row.landline_no || '',
  email: row.email || '',
  alternativeEmail: row.alternative_email || '',
  occupation: row.occupation || '',
  emergencyFullName: row.emergency_full_name || '',
  emergencyRelation: row.emergency_relation || '',
  emergencyContactNo: row.emergency_contact_no || '',
  emergencyEmail: row.emergency_email || '',
  emergencyAddress: row.emergency_address || '',
  emergencyPostalCode: row.emergency_postal_code || '',
  sponsorFullName: row.sponsor_full_name || '',
  sponsorRelation: row.sponsor_relation || '',
  sponsorContactNo: row.sponsor_contact_no || '',
  sponsorEmail: row.sponsor_email || '',
  sponsorProfession: row.sponsor_profession || '',
  sponsorAddress: row.sponsor_address || '',
  sponsorPostalCode: row.sponsor_postal_code || '',
  intendedCountry: row.intended_country || '',
  purposeOfVisit: row.purpose_of_visit || '',
  travelMonthYear: row.travel_month_year || '',
});

export const applicantDisplayName = (row) => {
  if (!row) return '';
  const parts = [row.first_name || row.firstName, row.middle_name || row.middleName, row.last_name || row.lastName].filter(Boolean);
  return parts.join(' ') || '—';
};
